import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './about.module.css';

export function AboutOriginStory() {
  return (
    <SectionWrapper
      background="white"
      className={styles.originSection}
      data-testid="about-section-origin"
    >
      <div className={styles.originGrid}>
        <div className={styles.sideEyebrow} aria-label="How Kudu started">
          <span aria-hidden="true" className={styles.sideLine} />
          <p>How Kudu started</p>
        </div>

        <div className={styles.originCopy}>
          <p>
            <span className={styles.dropCap}>K</span>udu started as one
            professor&apos;s frustration. In 2016, Alex Kusenko was teaching
            introductory physics at UCLA — and watching his students pay over
            two hundred dollars a semester for a textbook that didn&apos;t fit
            the course, a homework platform that lived in a separate app, and a
            clicker that required yet another login. Three accounts, three
            bills, none of them talking to each other.
          </p>
          <p>
            He thought there should be one tool that did all of it, designed by
            someone who&apos;d actually taught the class. He partnered with
            Warren Essey — a UCLA physicist who had trained as an engineer at
            Google — to build it. The first Kudu course shipped in physics that
            year. Faculty word of mouth carried it to chemistry, then
            astronomy, then humanities.
          </p>
          <p>
            Today Kudu is used at UCLA, UC San Diego, San Diego State, and
            other research universities, across physics, chemistry, biology,
            economics, history, comparative literature, political science, and
            more. What&apos;s stayed the same since the first course is who we
            work for: the professor in the classroom, and the student in the
            seat.
          </p>
        </div>
      </div>
    </SectionWrapper>
  );
}
